export default __webpack_public_path__ + "static/media/bsc-icon.87151316.webp";